import { defineModel, serializable } from '~/modules/api/model'

class OrganizationWithParent {
    @serializable()
    name: string

    @serializable()
    type: string

    @serializable()
    parents: { id: number; name: string }[]
}

export default defineModel(OrganizationWithParent)
